import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    allAgentEnquiresLoading: false,
    allAgentEnquiresSuccess: {},
    allAgentEnquiresError: '',

    allMasterAgentEnquiresLoading: false,
    allMasterAgentEnquiresSuccess: {},
    allMasterAgentEnquiresError: '',
}

export const agentEnquiresSlice = createSlice({
    name: 'agentEnquires',
    initialState,
    reducers: {

        setAllAgentEnquiresLoading: (state, action) => {
            state.allAgentEnquiresLoading = true;
            state.allAgentEnquiresSuccess = null;
            state.allAgentEnquiresError = '';
        },
        setAllAgentEnquiresSuccess: (state, action) => {
            state.allAgentEnquiresLoading = false;
            state.allAgentEnquiresSuccess = action.payload;
            state.allAgentEnquiresError = '';
        },
        setAllAgentEnquiresError: (state, action) => {
            state.allAgentEnquiresLoading = false;
            state.allAgentEnquiresSuccess = null;
            state.allAgentEnquiresError = action.payload;
        },

        setAllMasterAgentEnquiresLoading: (state, action) => {
            state.allMasterAgentEnquiresLoading = true;
            state.allMasterAgentEnquiresSuccess = null;
            state.allMasterAgentEnquiresError = '';
        },
        setAllMasterAgentEnquiresSuccess: (state, action) => {
            state.allMasterAgentEnquiresLoading = false;
            state.allMasterAgentEnquiresSuccess = action.payload;
            state.allMasterAgentEnquiresError = '';
        },
        setAllMasterAgentEnquiresError: (state, action) => {
            state.allMasterAgentEnquiresLoading = false;
            state.allMasterAgentEnquiresSuccess = null;
            state.allMasterAgentEnquiresError = action.payload;
        },
    }
})

export const {
    setAllAgentEnquiresLoading, setAllAgentEnquiresSuccess, setAllAgentEnquiresError,
    setAllMasterAgentEnquiresLoading, setAllMasterAgentEnquiresSuccess, setAllMasterAgentEnquiresError,
} = agentEnquiresSlice.actions;


export default agentEnquiresSlice.reducer;